import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Dimensions, TouchableOpacity, Pressable, Text } from 'react-native';
import SolidButtonContainer from '../../../../components/shared/Buttons/SolidButton.container';
import Select from '../../../../components/shared/FieldBuilder/Select/ReactSelect.component';
import I18n from '../../../../components/shared/i18n/I18n.component';
import colors from '../../../../config/colors';
import getShadowStyle from '../../../../config/shadow';
import { Privileges } from '../../../../constants/roleTypes.constant';
import httpService from '../../../../services/http.service';
import { i18nService } from '../../../../services/i18n.service';
import { hasPermissionOnBusinessUnit } from '../../../../utils/globals.utils';
import {
	EmployeeSelector,
	ProjectSelector,
	searchLocation,
} from './ExistingLocationSettingsModal.utils';
import ButtonV2 from '../../../../components/shared/Buttons/ButtonV2.container';

interface Props {
	usersList: [];
	locationsList: any[];
	projectsList: any;
	onNext: Function;
	refresh(): void;
	unitIds?: number[];
	businessUnitsList: any[];
	onClose(): void;
}

const windowHeight = Dimensions.get('window').height;
const windowWidth = Dimensions.get('window').width;

const ExistingLocationSettingsModal = ({
	locationsList,
	projectsList,
	onNext,
	refresh,
	unitIds,
	businessUnitsList,
	onClose,
}: Props) => {
	const [activeIndex, setActiveIndex] = useState(0);
	const [projectList, setProjectList] = useState(projectsList);
	const [locationList, setLocationsList] = useState(locationsList);

	const [userIds, setUserIds] = useState([]);
	const [locationIds, setLocationIds] = useState([]);
	const [projectLocationIds, setProjectLocationIds] = useState([]);
	const [projectIds, setProjectIds] = useState([]);
	const [disableSave, setDisableSave] = useState(true);
	const [unitId, setUnitId] = useState(unitIds?.length === 1 && unitIds?.[0]);

	useEffect(() => {
		let disable = true;
		if (!!projectLocationIds.length && !!projectIds.length) {
			if (!!locationIds.length === !!userIds.length) {
				disable = false;
			}
		}
		if (!!locationIds.length && !!userIds.length) {
			if (!!projectLocationIds.length === !!projectIds.length) {
				disable = false;
			}
		}
		setDisableSave(disable);
	}, [userIds, projectIds, locationIds, projectLocationIds]);

	useEffect(() => {
		if (unitId) {
			onSwitchTab(0);
			gerProjectsList();
			(async () => {
				const locs = await searchLocation('', unitId);
				setLocationsList(locs || []);
			})();
		}
	}, [unitId]);

	const gerProjectsList = async () => {
		try {
			const res = await httpService.api<any>({
				type: 'getUnitProjectsFilter',
				query: {
					pageName: 'locationSettings',
					unitIds: unitId,
				},
			});

			if (res) {
				setProjectList(res);
			}
		} catch (e) {}
	};

	const onSave = async () => {
		try {
			const res = await httpService.api<any>({
				type: 'associateLocation',
				data: {
					locationIds,
					userIds,
					projectLocationIds,
					projectIds,
					unitId,
				},
			});
			onNext(refresh());
		} catch (e) {}
	};

	const onSwitchTab = (index: number) => {
		setActiveIndex(index);
		setUserIds([]);
		setLocationIds([]);
		setProjectLocationIds([]);
		setProjectIds([]);
	};

	return (
		<View
			style={[
				styles.container,
				{ height: windowHeight - 200, width: windowWidth - 550 },
			]}
		>
			<View style={{ flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 5, zIndex: 100 }}>
				<View style={{ flexDirection: 'row-reverse', alignItems: 'center', gap: 16,  zIndex: 100 }}>
					<I18n
						size={20}
						weight='bold'
						color='primaryDarkBlue'
						style={{ minWidth: '40%'}}
					>
						{`${i18nService.translate(
							'existingLocationSettingsModal.title',
						)} ${
							projectsList.length
								? i18nService.translate(
										'existingLocationSettingsModal.titleOrProject',
								)
								: ''
						}`}
					</I18n>

					{businessUnitsList.length > 1 ? (
						<>
							<Select
								options={businessUnitsList}
								onChange={setUnitId}
								value={unitId}
								style={{
									backgroundColor: colors.white,
									borderColor: '#D1D4DC',
									borderRadius: 8,
									zIndex: 1000,
								}}
								styles={{
									singleValue: {
										color: '#282C6F',
										fontFamily: 'RubikRegular',
									},
								}}
							/>
						</>
					) : null}

				</View>

				<Pressable onPress={onClose} style={styles.closeButton}>
					<Text style={styles.closeButtonText}>×</Text>
				</Pressable>
			</View>

			<View
				style={{
					//zIndex: 1,
					flexDirection: 'row-reverse',
					backgroundColor: colors.white,
					alignItems: 'center',
					paddingTop: 15,
					marginLeft: 300,
				}}
			>
				
			</View>
			{unitId ? (
				<>
					<View style={styles.tabsContainer}>
						<TouchableOpacity
							onPress={() => onSwitchTab(0)}
							style={[
								styles.buttonTab,
								{
									borderBottomColor:
										activeIndex === 0
											? colors.primaryDarkBlue
											: colors.white,
								},
							]}
						>
							<I18n size={14} color='primaryDarkBlue' weight='bold'>
								existingLocationSettingsModal.employees
							</I18n>
						</TouchableOpacity>

						{projectList.length ? (
							<TouchableOpacity
								onPress={() => onSwitchTab(1)}
								style={[
									styles.buttonTab,
									{
										borderBottomColor:
											activeIndex === 1
												? colors.primaryDarkBlue
												: colors.white,
									},
								]}
							>
								<I18n size={14} color='primaryDarkBlue' weight='bold'>
									existingLocationSettingsModal.projects
								</I18n>
							</TouchableOpacity>
						) : (
							<View />
						)}
					</View>

					<View
						style={[
							styles.tabContainer,
							{ height: windowHeight - 440 },
						]}
					>
						{activeIndex === 0 ? (
							<EmployeeSelector
								locations={locationList}
								userIds={userIds}
								locationIds={locationIds}
								setUserIds={setUserIds}
								setLocationIds={setLocationIds}
								unitId={unitId}
								tableHeight={windowHeight - 480}
							/>
						) : projectList.length ? (
							<ProjectSelector
								projects={projectList}
								locations={locationList}
								projectIds={projectIds}
								locationIds={projectLocationIds}
								setProjectLocationIds={setProjectLocationIds}
								setProjectIds={setProjectIds}
								unitId={unitId}
								tableHeight={windowHeight - 480}
							/>
						) : (
							<View />
						)}
					</View>
				</>
			) : null}
			<View
				style={{
					flexDirection: 'row',
					marginVertical: 15,
					zIndex: -1,
					gap: 16
				}}
			>
				<ButtonV2 
					preset='primary'
					onPress={() => onSave()}
					disabled={
						disableSave ||
						(!hasPermissionOnBusinessUnit(
							unitId,
							Privileges.ROLE_LOCATION_ASSOCIATION_WRITE,
						) &&
							!hasPermissionOnBusinessUnit(
								unitId,
								Privileges.ROLE_LOCATION_WRITE,
							))
					}
					 >
					<I18n color={colors.white} size={14} weight='400'>
						general.save
					</I18n>
				</ButtonV2>

				<ButtonV2
					preset='outline'
					onPress={onNext}
				>
					<I18n color='titlePrimary' size={14} weight='400'>
						general.cancel
					</I18n>
				</ButtonV2>
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		backgroundColor: colors.white,
		borderRadius: 20,
		paddingVertical: 30,
		paddingHorizontal: 20,
		minWidth: 875,
		maxWidth: 1500,
	},
	separator: {
		backgroundColor: colors.primary,
		height: 2,
		width: '100%',
		marginBottom: 5,
	},
	tabsContainer: {
		flexDirection: 'row-reverse',
		borderBottomWidth: 1,
		borderBottomColor: '#e7e7e8',
	},
	buttonTab: {
		width: 150,
		borderBottomWidth: 6,
		alignItems: 'center',
		padding: 3,
		marginTop: 20,
	},
	tabContainer: {
		padding: 20,
		marginBottom: 10,
		borderRadius: 8,
		borderTopRightRadius: 0,
		zIndex: 1,
		flexDirection: 'row-reverse',
		justifyContent: 'space-between',
	},
	field: {
		width: 150,
		paddingBottom: 15,
	},
	dataContainer: {
		width: '50%',
	},
	cancelButton: {
		marginHorizontal: 10,
		backgroundColor: colors.white,
		borderColor: colors.lightPrimary,
		borderWidth: 1,
	},
	closeButton: {
		padding: 4,
		marginLeft: 8,
	},
	closeButtonText: {
		fontSize: 28,
		color: colors.darkGrey,
		lineHeight: 28,
	},
});

export default ExistingLocationSettingsModal;
